export default {
  title: "供应商关系管理系统",
  systemSetting: "系统设置",
  logout: "退出登录",
};
